export default __webpack_public_path__ + "static/media/p1.9cdaa1ba.jpeg";